/* eslint-disable react/jsx-props-no-spreading */
import { useForm } from 'react-hook-form';
import React from 'react';

const Form = ({ handleFormSubmit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const onSubmit = data => handleFormSubmit(data);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="field">
        <div className="control name">
          <input
            className="input"
            id="Name"
            type="text"
            placeholder="Name"
            {...register('name', { required: true })}
            error={errors.name?.type === 'required' && 'Name is required'}
            onChange={e => setValue('name', e.target.value)}
          />
        </div>
      </div>
      <div className="field">
        <div className="control">
          <input
            className="input"
            id="phone"
            type="number"
            placeholder="Phone Number"
            {...register('phone', { required: true })}
            error={
              errors.phone?.type === 'required' && 'Phone Number is required'
            }
            onChange={e => setValue('email', e.target.value)}
          />
        </div>
      </div>
      <div className="field">
        <div className="control msg">
          <textarea
            className="textarea"
            rows="4"
            id="message"
            type="text"
            placeholder="Message"
            {...register('message', { required: true })}
            error={errors.message?.type === 'required' && 'Message is required'}
            onChange={e => setValue('message', e.target.value)}
          />
        </div>
      </div>

      <div className="buttons has-addons is-right">
        <button type="submit" className="button is-rounded">
          CONFIRM BOOKING
          <i className="fas fa-long-arrow-alt-right icon" />
        </button>
      </div>
    </form>
  );
};

export default Form;
